import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";

import { Toaster, toast } from "react-hot-toast";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import DashboardLayout from './DashboardLayout';

const GenerateEmployee = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("Consultant");
    const [showPassword, setShowPassword] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_BASEURL}/api/employee/createEmployee`,
                { email, password, role, firstName, lastName },
                {
                    withCredentials: true,
                    headers: { "Content-Type": "application/json" },
                }
            );
            toast.success("Employee generated successfully!");
        } catch (error) {
            toast.error("Generation failed");
        }
    };

    return (
        <DashboardLayout>
            <Toaster position="top-right" reverseOrder={false} />
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", backgroundColor: "#f3f4f6", padding: "1.5rem" }}>
                <div style={{ backgroundColor: "white", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", borderRadius: "8px", padding: "1.5rem", width: "100%", maxWidth: "500px" }}>
                    <h1 style={{ fontSize: "1.875rem", fontWeight: "600", textAlign: "center", color: "#1f2937", marginBottom: "1.5rem" }}>
                        Generate Employee
                    </h1>

                    <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
                        <div>
                            <label style={{ fontSize: "0.875rem", fontWeight: "500", color: "#374151" }}>First-Name</label>
                            <input
                                type="text"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                placeholder="Enter First-Name "
                                required
                                style={{ width: "100%", padding: "0.5rem", border: "1px solid #d1d5db", borderRadius: "6px", marginTop: "0.25rem" }}
                            />
                        </div>
                        <div>
                            <label style={{ fontSize: "0.875rem", fontWeight: "500", color: "#374151" }}>Last-Name</label>
                            <input
                                type="text"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                placeholder="Enter Last-Name"
                                required
                                style={{ width: "100%", padding: "0.5rem", border: "1px solid #d1d5db", borderRadius: "6px", marginTop: "0.25rem" }}
                            />
                        </div>
                        <div>
                            <label style={{ fontSize: "0.875rem", fontWeight: "500", color: "#374151" }}>Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter email"
                                required
                                style={{ width: "100%", padding: "0.5rem", border: "1px solid #d1d5db", borderRadius: "6px", marginTop: "0.25rem" }}
                            />
                        </div>

                        <div style={{ position: "relative" }}>
                            <label style={{ fontSize: "0.875rem", fontWeight: "500", color: "#374151" }}>Password</label>
                            <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter password"
                                required
                                style={{ width: "100%", padding: "0.5rem", border: "1px solid #d1d5db", borderRadius: "6px", marginTop: "0.25rem" }}
                            />
                            <IconButton
                                onClick={() => setShowPassword(!showPassword)}
                                sx={{
                                    position: "absolute",
                                    right: 10,
                                    top: "65%",
                                    transform: "translateY(-50%)",
                                    color: "#666",
                                }}
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </div>

                        <div>
                            <label style={{ fontSize: "0.875rem", fontWeight: "500", color: "#374151" }}>Select Role</label>
                            <select
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                                style={{ width: "100%", padding: "0.5rem", border: "1px solid #d1d5db", borderRadius: "6px", marginTop: "0.25rem" }}
                            >
                                <option value="Consultant">Consultant</option>
                                <option value="Intern">Intern</option>
                                <option value="Freelancer">Freelancer</option>
                                <option value="Software Developer">Software Developer</option>
                                <option value="Manager">Manager</option>
                                <option value="QA Tester">QA Tester</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        <button type="submit" style={{ width: "100%", backgroundColor: "#2563eb", color: "white", padding: "0.75rem", borderRadius: "6px", fontWeight: "600", cursor: "pointer" }}>
                            Generate
                        </button>
                    </form>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default GenerateEmployee;